import React from 'react'
import "./CustomCalendar.css";
export default function Label({ controlId, className, labelText, isCompulsary }) {
    return (
        // <label className={className}>{labelText}</label>
        <label htmlFor={controlId} className={className ? className : ""} >
            {labelText} {isCompulsary && <span className="text-danger">*</span>}
        </label >
    )
}
